import { formatPhone } from '../../../../utils/formatString';
export function phoneSelector(state) {
  return formatPhone(state.authentication.twoFactor.phoneState.phone);
}